import axios from 'axios';
import { CORE_API } from '../env.config.js';

/**
 * Creates a WidgetSubmission
 * @param {Object} coreToken - The core token object with token and provider_id
 * @returns {Promise} Axios response
 */
const createWidgetSubmission = async (coreToken) => {
  const baseURL = CORE_API;

  try {
    const response = await axios.post(
      'widget_submissions',
      {
        data: {
          attributes: {
            group_id: coreToken.provider_id,
          }
        }
      },
      {
        baseURL,
        headers: {
          Authorization: `Bearer ${coreToken.token}`,
          'X-Application-Source': 'widgets',
        },
      },
    );

    return response;
  } catch (error) {
    return error;
  }
};

export default createWidgetSubmission;

